import { Component } from '@angular/core';

import { QuestionsService } from './services';

import '../style/app.scss';

@Component({
  selector: 'my-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.scss')],
  providers:[ QuestionsService ]
})
export class AppComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts